import { render, staticRenderFns } from "./DraftsMenu.vue?vue&type=template&id=218d93a6&scoped=true"
import script from "./DraftsMenu.vue?vue&type=script&lang=ts"
export * from "./DraftsMenu.vue?vue&type=script&lang=ts"
import style0 from "./DraftsMenu.vue?vue&type=style&index=0&id=218d93a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d93a6",
  null
  
)

export default component.exports